import { proxy } from '@/utils'

export const core = {
  mixins: [ proxy() ],

  props: {
    trueValue: {
      type: null,
      default: true
    },
    falseValue: {
      type: null,
      default: false
    },

    loading: Boolean,
    disabled: Boolean,
    readonly: Boolean
  },

  computed: {
    checked() {
      if (this.proxy === this.trueValue) {
        return true
      }

      return false
    }
  },

  methods: {
    toggle() {
      if (!this.disabled && !this.readonly) {
        if (this.proxy === this.falseValue) {
          this.proxy = this.trueValue
        } else {
          this.proxy = this.falseValue
        }
      }
    }
  }
}
